define(["react","underscore","prop-types","classnames","@bingads-webui-react/with-default-styles","roosterjs","@fluentui/react/lib/TextField","@fluentui/react/lib/Dialog","@fluentui/react/lib/Button"], function(__WEBPACK_EXTERNAL_MODULE__3__, __WEBPACK_EXTERNAL_MODULE__9__, __WEBPACK_EXTERNAL_MODULE__10__, __WEBPACK_EXTERNAL_MODULE__11__, __WEBPACK_EXTERNAL_MODULE__35__, __WEBPACK_EXTERNAL_MODULE__925__, __WEBPACK_EXTERNAL_MODULE__933__, __WEBPACK_EXTERNAL_MODULE__934__, __WEBPACK_EXTERNAL_MODULE__935__) { return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 922);
/******/ })
/************************************************************************/
/******/ ({

/***/ 10:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__10__;

/***/ }),

/***/ 11:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__11__;

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__3__;

/***/ }),

/***/ 35:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__35__;

/***/ }),

/***/ 9:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__9__;

/***/ }),

/***/ 922:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(923);


/***/ }),

/***/ 923:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "RichTextEditor", {
  enumerable: true,
  get: function get() {
    return _richTextEditor.RichTextEditor;
  }
});
Object.defineProperty(exports, "RibbonButtons", {
  enumerable: true,
  get: function get() {
    return _ribbonButtons.RibbonButtons;
  }
});

var _richTextEditor = __webpack_require__(924);

var _ribbonButtons = __webpack_require__(931);

/***/ }),

/***/ 924:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RichTextEditor = void 0;

var _classnames = _interopRequireDefault(__webpack_require__(11));

var _underscore = _interopRequireDefault(__webpack_require__(9));

var _propTypes = _interopRequireDefault(__webpack_require__(10));

var _react = _interopRequireWildcard(__webpack_require__(3));

var _roosterjs = __webpack_require__(925);

var _withDefaultStyles = __webpack_require__(35);

var _ribbon = __webpack_require__(926);

var _ribbonPlugin = __webpack_require__(961);

var _statePlugin = __webpack_require__(963);

var _ribbonButtons = __webpack_require__(931);

var _getDefaultFormat = __webpack_require__(964);

var _contentFilterPlugin = __webpack_require__(965);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

// Create a dangling div to call editor core api for overwrite
const tmpDiv = document.createElement('div');
const dummyEditor = new _roosterjs.Editor(tmpDiv);

const UnstyledRichTextEditor = ({
  className,
  classes,
  onBlur: _onBlur,
  initialContent,
  onContentChanged,
  ribbonButtons,
  options,
  i18n,
  placeholder
}) => {
  const editorRef = (0, _react.useRef)(null);
  const ribbonRef = (0, _react.useRef)(null);

  const _useState = (0, _react.useState)(null),
        _useState2 = _slicedToArray(_useState, 2),
        editor = _useState2[0],
        setEditor = _useState2[1];

  const _useState3 = (0, _react.useState)(null),
        _useState4 = _slicedToArray(_useState3, 2),
        editorContent = _useState4[0],
        setEditorContent = _useState4[1];

  const format = editor && (0, _roosterjs.getFormatState)(editor) || {};
  const allPlugins = (0, _react.useMemo)(() => ({
    contentEdit: new _roosterjs.ContentEdit({
      autoLink: true
    }),
    hyperLink: new _roosterjs.HyperLink(),
    paste: new _roosterjs.Paste(),
    contentFilterPlugin: new _contentFilterPlugin.ContentFilterPlugin(),
    ribbon: new _ribbonPlugin.RibbonPlugin(),
    contentState: new _statePlugin.ContentStatePlugin(options)
  }), [options]);
  const allPluginsArray = (0, _react.useMemo)(() => Object.values(allPlugins), [allPlugins]);
  const editorOptions = (0, _react.useMemo)(() => ({
    defaultFormat: (0, _getDefaultFormat.getDefaultFormat)(options.defaultFormat),
    plugins: allPluginsArray,
    initialContent: _roosterjs.HtmlSanitizer.sanitizeHtml(_roosterjs.HtmlSanitizer.convertInlineCss(initialContent)),
    coreApiOverride: {
      // TODO refactor to use the newly added originalapi https://microsoft.github.io/roosterjs/docs/interfaces/roosterjs_editor_types.editorcore.html#originalapi
      // override this api to force pasteAsText
      createPasteFragment: (core, clipboardData, position, pasteAsText, applyCurrentStyle) => dummyEditor.core.api.createPasteFragment(core, clipboardData, position, options.pasteAsText, applyCurrentStyle)
    },
    experimentalFeatures: [_roosterjs.ExperimentalFeatures.ListItemAlignment]
  }), [initialContent, allPluginsArray, options]);
  const handleContentChanged = (0, _react.useCallback)((content, shouldNotify) => {
    setEditorContent(content);

    if (shouldNotify) {
      onContentChanged(content);
    }
  }, [onContentChanged]);
  (0, _react.useEffect)(() => {
    allPlugins.ribbon.registerRef(ribbonRef);
  }, [ribbonRef, allPlugins]);
  (0, _react.useEffect)(() => {
    allPlugins.contentState.registerObs(handleContentChanged);
  }, [handleContentChanged, allPlugins]);
  (0, _react.useEffect)(() => {
    if (editorRef.current && !editor) {
      const newEditor = new _roosterjs.Editor(editorRef.current, editorOptions);
      setEditor(newEditor);
    }
  }, [editor, editorOptions, editorRef]);
  (0, _react.useEffect)(() => () => {
    if (editor) {
      editor.dispose();
      setEditor(null);
    }
  }, [editor]);
  return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement("div", {
    className: (0, _classnames.default)('rich-text-editor-root', classes.root)
  }, _react.default.createElement(_ribbon.Ribbon, {
    i18n: i18n,
    plugin: allPlugins.ribbon,
    ref: ribbonRef,
    buttons: ribbonButtons
  }), _react.default.createElement("div", {
    className: classes.editorRoot
  }, _react.default.createElement("div", {
    className: (0, _classnames.default)(className, 'rich-text-editor-wrapper', classes.editorContainer),
    onBlur: () => _onBlur(editor.getContent()),
    ref: editorRef,
    "aria-placeholder": placeholder
  }), !editorContent && !format.isBullet && !format.isNumbering && placeholder && _react.default.createElement("div", {
    className: (0, _classnames.default)(classes.editorPlaceholder, 'rich-text-editor-placeholder')
  }, placeholder))));
};

UnstyledRichTextEditor.propTypes = {
  className: _propTypes.default.string,
  onBlur: _propTypes.default.func,
  classes: _propTypes.default.shape({}).isRequired,
  initialContent: _propTypes.default.string,
  onContentChanged: _propTypes.default.func,
  ribbonButtons: _propTypes.default.arrayOf(_propTypes.default.string),
  i18n: _propTypes.default.shape({
    getString: _propTypes.default.func
  }).isRequired,
  placeholder: _propTypes.default.string,
  options: _propTypes.default.shape({})
};
UnstyledRichTextEditor.defaultProps = {
  className: null,
  onBlur: _underscore.default.noop,
  initialContent: '',
  onContentChanged: _underscore.default.noop,
  ribbonButtons: Object.values(_ribbonButtons.RibbonButtons),
  placeholder: null,
  options: {
    defaultFormat: {},
    pasteAsText: true
  }
};
const RichTextEditor = (0, _withDefaultStyles.withDefaultStyles)(UnstyledRichTextEditor, (_c, {
  palette = {}
}) => ({
  root: {
    border: '1px solid rgb(96, 94, 92)',
    borderRadius: '2px',
    '&:focus-within': {
      outline: `2px solid ${palette.accent}`,
      outlineOffset: '-1px'
    }
  },
  editorRoot: {
    position: 'relative',
    overflow: 'hidden'
  },
  editorPlaceholder: {
    position: 'absolute',
    top: '10px',
    left: '12px',
    marginRight: '12px',
    color: '#605E5C',
    pointerEvents: 'none'
  },
  editorContainer: {
    outline: 'transparent',
    minHeight: '240px',
    margin: '10px',
    lineBreak: 'anywhere'
  }
}));
exports.RichTextEditor = RichTextEditor;

/***/ }),

/***/ 925:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__925__;

/***/ }),

/***/ 926:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Ribbon = void 0;

var _classnames = _interopRequireDefault(__webpack_require__(11));

var _propTypes = _interopRequireDefault(__webpack_require__(10));

var _react = _interopRequireWildcard(__webpack_require__(3));

var _roosterjs = __webpack_require__(925);

var _withDefaultStyles = __webpack_require__(35);

var _editorRibbonStyle = __webpack_require__(927);

var _useForceUpdate = __webpack_require__(928);

var _ribbonButton = __webpack_require__(929);

var _ribbonButtons = __webpack_require__(931);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const UnstyledRibbon = ({
  classes,
  className,
  plugin,
  forceUpdate,
  buttons,
  i18n
}) => {
  const editor = plugin.getEditor();
  const format = editor && (0, _roosterjs.getFormatState)(editor);
  const onButtonClicked = (0, _react.useCallback)(() => forceUpdate(), [forceUpdate]);
  return editor ? _react.default.createElement("div", {
    className: (0, _classnames.default)('rich-text-editor-ribbon', className, classes.root)
  }, buttons.map(buttonName => _ribbonButtons.ribbonButtons[buttonName] ? _react.default.createElement(_ribbonButton.RibbonButton, {
    i18n: i18n,
    className: buttonName,
    classes: classes,
    key: buttonName,
    plugin: plugin,
    format: format,
    button: _ribbonButtons.ribbonButtons[buttonName],
    onClicked: onButtonClicked
  }) : null)) : null;
};

UnstyledRibbon.propTypes = {
  className: _propTypes.default.string,
  classes: _propTypes.default.shape({}).isRequired,
  // related ribbon plugin to access editor instance
  plugin: _propTypes.default.shape({}).isRequired,
  forceUpdate: _propTypes.default.func.isRequired,
  buttons: _propTypes.default.arrayOf(_propTypes.default.string).isRequired,
  i18n: _propTypes.default.shape({
    getString: _propTypes.default.func
  }).isRequired
};
UnstyledRibbon.defaultProps = {
  className: null
};
const RibbonBase = (0, _withDefaultStyles.withDefaultStyles)(UnstyledRibbon, _editorRibbonStyle.getEditorRibbonStyle);

const Ribbon = _react.default.forwardRef((props, ref) => {
  const _forceUpdate = (0, _useForceUpdate.useForceUpdate)();

  (0, _react.useImperativeHandle)(ref, () => ({
    forceUpdate: () => _forceUpdate()
  }));
  return _react.default.createElement(RibbonBase, _extends({}, props, {
    forwardedRef: ref,
    forceUpdate: _forceUpdate
  }));
});

exports.Ribbon = Ribbon;

/***/ }),

/***/ 927:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getEditorRibbonStyle = void 0;

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

const ribbonButtonSharedStyle = {
  backgroundColor: 'transparent',
  '&:not([disabled])': {
    '&:hover': {
      backgroundColor: 'rgba(244, 244, 244, 1)'
    },
    '&.checked': {
      backgroundColor: 'rgba(218, 218, 218, 1)'
    },
    cursor: 'pointer'
  }
};

const getEditorRibbonStyle = () => ({
  // Ribbon root styles
  root: {},
  // Ribbon button wrapper styles
  buttonContainer: {
    position: 'relative',
    width: '32px',
    height: '32px',
    overflow: 'visible'
  },
  // Ribbon image button styles
  imgButton: _objectSpread({}, ribbonButtonSharedStyle, {
    borderWidth: 0,
    borderRadius: '4px',
    margin: '2px',
    padding: 0,
    '&:disabled': {
      filter: 'opacity(60%)'
    }
  }),
  // Ribbon text only button styles
  textButton: _objectSpread({}, ribbonButtonSharedStyle, {
    height: '32px',
    verticalAlign: 'top',
    borderWidth: '0',
    borderRadius: '3px'
  }),
  // Ribbton button dropdown list container styles
  dropdown: {
    zIndex: 1,
    border: '1px solid white',
    backgroundColor: 'white',
    display: 'inline-block',
    padding: '4px',
    boxShadow: '1px 1px 3px gray',
    position: 'absolute',
    top: '14px',
    left: '0'
  },
  // Ribbton button dropdown item styles
  dropdownItem: {
    cursor: 'pointer',
    padding: '2px',
    whiteSpace: 'nowrap',
    minWidth: '60px',
    '&:hover': {
      backgroundColor: 'rgba(244, 244, 244, 1)'
    }
  }
});

exports.getEditorRibbonStyle = getEditorRibbonStyle;

/***/ }),

/***/ 928:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useForceUpdate = void 0;

var _react = __webpack_require__(3);

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

const useForceUpdate = () => {
  const _useState = (0, _react.useState)(0),
        _useState2 = _slicedToArray(_useState, 2),
        setInternalValue = _useState2[1];

  return () => setInternalValue(internalValue => internalValue + 1);
};

exports.useForceUpdate = useForceUpdate;

/***/ }),

/***/ 929:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RibbonButton = void 0;

var _classnames = _interopRequireDefault(__webpack_require__(11));

var _propTypes = _interopRequireDefault(__webpack_require__(10));

var _react = _interopRequireWildcard(__webpack_require__(3));

var _ribbonDropdown = __webpack_require__(930);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

const RibbonButton = ({
  classes,
  button,
  plugin,
  format,
  onClicked,
  className,
  i18n
}) => {
  const _useState = (0, _react.useState)(false),
        _useState2 = _slicedToArray(_useState, 2),
        isDropdownShown = _useState2[0],
        setIsDropdownShown = _useState2[1];

  const editor = (0, _react.useMemo)(() => plugin.getEditor(), [plugin]);
  const editorDocument = (0, _react.useMemo)(() => plugin.getEditor().getDocument(), [plugin]);
  const isImageButton = (0, _react.useMemo)(() => !!button.image, [button]);
  const buttonClassName = (0, _react.useMemo)(() => {
    const isChecked = format && button.checked && button.checked(format, editor);
    return (0, _classnames.default)(isChecked ? 'checked' : '', isImageButton ? classes.imgButton : classes.textButton, 'ribbon-button-wrapper', `${className}-button`);
  }, [button, className, classes, editor, format, isImageButton]);
  const onHideDropdown = (0, _react.useCallback)(() => {
    // Shadow edit mode is enabled when hover on dropdown item, need to reset it
    // ShadowEdit is a live preview when applying fomat style
    editor.stopShadowEdit();
    editorDocument.removeEventListener('click', onHideDropdown);
    setIsDropdownShown(false);
  }, [editorDocument, editor]);
  const onShowDropdown = (0, _react.useCallback)(e => {
    if (!button.preserveOnClickAway) {
      editorDocument.addEventListener('click', onHideDropdown);
    } // For React 17 not dismiss the dropdown


    e.stopPropagation();
    setIsDropdownShown(true);
  }, [button, editorDocument, onHideDropdown]);
  const handleOnClick = (0, _react.useCallback)(value => {
    onHideDropdown();

    if (button.onClick) {
      button.onClick(editor, value);
    }

    onClicked();
  }, [button, editor, onHideDropdown, onClicked]); // Make sure event listener is cleaned up

  (0, _react.useEffect)(() => () => editorDocument.removeEventListener('click', onHideDropdown), [editorDocument, onHideDropdown]);
  return _react.default.createElement("span", {
    className: (0, _classnames.default)(classes.buttonContainer)
  }, _react.default.createElement("button", {
    className: buttonClassName,
    disabled: !!button.isDisabled && button.isDisabled(editor, format),
    onClick: button.dropdownItems ? onShowDropdown : handleOnClick
  }, isImageButton ? _react.default.createElement("img", {
    src: button.image,
    width: 32,
    height: 32,
    title: button.title,
    alt: i18n.getString(button.title)
  }) : i18n.getString(button.title)), button.dropdownItems && isDropdownShown && _react.default.createElement(_ribbonDropdown.RibbonDropdown, {
    classes: classes,
    i18n: i18n,
    editor: editor,
    button: button,
    onHideDropdown: onHideDropdown
  }));
};

exports.RibbonButton = RibbonButton;
RibbonButton.propTypes = {
  className: _propTypes.default.string.isRequired,
  i18n: _propTypes.default.shape({
    getString: _propTypes.default.func
  }).isRequired,
  classes: _propTypes.default.shape({}).isRequired,
  // button configuration input
  button: _propTypes.default.shape({}).isRequired,
  // related ribbon plugin to access editor instance
  plugin: _propTypes.default.shape({}).isRequired,
  // current editor format state object
  format: _propTypes.default.shape({}).isRequired,
  // callback when button has been clicked
  onClicked: _propTypes.default.func.isRequired
};

/***/ }),

/***/ 930:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RibbonDropdown = void 0;

var _underscore = _interopRequireDefault(__webpack_require__(9));

var _propTypes = _interopRequireDefault(__webpack_require__(10));

var _react = _interopRequireWildcard(__webpack_require__(3));

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const RibbonDropdownItem = ({
  classes,
  editor,
  itemName,
  displayName,
  onClick,
  i18n
}) => {
  const handleOnClick = (0, _react.useCallback)(() => {
    editor.stopShadowEdit();
    onClick(editor, itemName);
  }, [onClick, editor, itemName]);
  const handleOnMouseOver = (0, _react.useCallback)(() => {
    editor.startShadowEdit();
    onClick(editor, itemName);
  }, [onClick, editor, itemName]);
  return _react.default.createElement("div", {
    className: classes.dropdownItem,
    tabIndex: "0",
    role: "button",
    key: itemName,
    onClick: handleOnClick,
    onKeyDown: () => {},
    onMouseOver: handleOnMouseOver,
    onFocus: handleOnMouseOver
  }, i18n.getString(displayName));
};

const RibbonDropdown = ({
  classes,
  editor,
  button,
  onHideDropdown,
  i18n
}) => _react.default.createElement("div", {
  className: classes.dropdown
}, Object.keys(button.dropdownItems).map(key => button.dropdownRenderer ? _react.default.createElement("div", {
  key: key
}, button.dropdownRenderer(editor, i18n, onHideDropdown, key, button.dropdownItems[key])) : _react.default.createElement(RibbonDropdownItem, {
  i18n: i18n,
  key: key,
  classes: classes,
  editor: editor,
  itemName: key,
  displayName: button.dropdownItems[key],
  onClick: button.onClick
})));

exports.RibbonDropdown = RibbonDropdown;
RibbonDropdownItem.propTypes = {
  classes: _propTypes.default.shape({}).isRequired,
  editor: _propTypes.default.shape({}).isRequired,
  itemName: _propTypes.default.string.isRequired,
  displayName: _propTypes.default.string.isRequired,
  onClick: _propTypes.default.func,
  i18n: _propTypes.default.shape({
    getString: _propTypes.default.func
  }).isRequired
};
RibbonDropdownItem.defaultProps = {
  onClick: _underscore.default.noop
};
RibbonDropdown.propTypes = {
  i18n: _propTypes.default.shape({
    getString: _propTypes.default.func
  }).isRequired,
  classes: _propTypes.default.shape({}).isRequired,
  editor: _propTypes.default.shape({}).isRequired,
  button: _propTypes.default.shape({}).isRequired,
  onHideDropdown: _propTypes.default.func.isRequired
};

/***/ }),

/***/ 931:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RibbonButtons = exports.ribbonButtons = void 0;

var _roosterjs = __webpack_require__(925);

var _insertLinkDialog = __webpack_require__(932);

const BOLD_SVG = __webpack_require__(937);

const ITALIC_SVG = __webpack_require__(938);

const UNDERLINE_SVG = __webpack_require__(939);

const BULLETS_SVG = __webpack_require__(940);

const HEADER_SVG = __webpack_require__(941);

const NUMBERING_SVG = __webpack_require__(942);

const OUTDENT_SVG = __webpack_require__(943);

const INDENT_SVG = __webpack_require__(944);

const ALIGNLEFT_SVG = __webpack_require__(945);

const ALIGNCENTER_SVG = __webpack_require__(946);

const ALIGNRIGHT_SVG = __webpack_require__(947);

const UNLINK_SVG = __webpack_require__(948);

const STRIKETHROUGH_SVG = __webpack_require__(949);

const LTR_SVG = __webpack_require__(950);

const RTL_SVG = __webpack_require__(951);

const UNDO_SVG = __webpack_require__(952);

const REDO_SVG = __webpack_require__(953);

const REMOVEFORMAT_SVG = __webpack_require__(954);

const BACKCOLOR_SVG = __webpack_require__(955);

const TEXTCOLOR_SVG = __webpack_require__(956);

const CREATELINK_SVG = __webpack_require__(957);

const FONTSIZE_SVG = __webpack_require__(958);

const FONTNAME_SVG = __webpack_require__(959);

const CAPITALIZATION_SVG = __webpack_require__(960);
/**
 * Refer here below link for more button functionality if needed
 * https://github.com/microsoft/roosterjs/blob/master/demo/scripts/controls/ribbon/ribbonButtons.ts
 */


const ribbonButtons = {
  bold: {
    title: _TL_('Bold'),
    image: BOLD_SVG,
    onClick: _roosterjs.toggleBold,
    checked: format => format.isBold
  },
  italic: {
    title: _TL_('Italic'),
    image: ITALIC_SVG,
    onClick: _roosterjs.toggleItalic,
    checked: format => format.isItalic
  },
  underline: {
    title: _TL_('Underline'),
    image: UNDERLINE_SVG,
    onClick: _roosterjs.toggleUnderline,
    checked: format => format.isUnderline
  },
  fontName: {
    title: _TL_('Font'),
    image: FONTNAME_SVG,
    onClick: _roosterjs.setFontName,
    // No need to translate this
    dropdownItems: {
      Arial: 'Arial',
      Calibri: 'Calibri',
      'Courier New': 'Courier New',
      Tahoma: 'Tahoma',
      'Times New Roman': 'Times New Roman'
    }
  },
  fontSize: {
    title: _TL_('Font size'),
    image: FONTSIZE_SVG,
    onClick: _roosterjs.setFontSize,
    dropdownItems: {
      '8pt': '8',
      '10pt': '10',
      '12pt': '12',
      '16pt': '16',
      '20pt': '20',
      '36pt': '36',
      '72pt': '72'
    }
  },
  textColor: {
    title: _TL_('Text color'),
    image: TEXTCOLOR_SVG,
    onClick:
    /* istanbul ignore next */
    (editor, color) => (0, _roosterjs.setTextColor)(editor, {
      lightModeColor: color,
      darkModeColor: (0, _roosterjs.getDarkColor)(color)
    }),
    // TODO use other component instead of dropdown
    dropdownItems: {
      '#51a7f9': 'Light Blue',
      '#6fc040': 'Light Green',
      '#f5d427': 'Light Yellow',
      '#f3901d': 'Light Orange',
      '#ed5c57': 'Light Red',
      '#b36ae2': 'Light Purple',
      '#0c64c0': 'Blue',
      '#0c882a': 'Green',
      '#dcbe22': 'Yellow',
      '#de6a19': 'Orange',
      '#c82613': 'Red',
      '#763e9b': 'Purple',
      '#174e86': 'Dark Blue',
      '#0f5c1a': 'Dark Green',
      '#c3971d': 'Dark Yellow',
      '#be5b17': 'Dark Orange',
      '#861106': 'Dark Red',
      '#5e327c': 'Dark Purple',
      '#002451': 'Darker Blue',
      '#06400c': 'Darker Green',
      '#a37519': 'Darker Yellow',
      '#934511': 'Darker Orange',
      '#570606': 'Darker Red',
      '#3b204d': 'Darker Purple',
      '#ffffff': 'White',
      '#cccccc': 'Light Gray',
      '#999999': 'Gray',
      '#666666': 'Dark Gray',
      '#333333': 'Darker Gray',
      '#000000': 'Black'
    }
  },
  backColor: {
    title: _TL_('Highlight'),
    image: BACKCOLOR_SVG,
    onClick:
    /* istanbul ignore next */
    (editor, color) => (0, _roosterjs.setBackgroundColor)(editor, {
      lightModeColor: color,
      darkModeColor: (0, _roosterjs.getDarkColor)(color)
    }),
    dropdownItems: {
      '#00ffff': 'Cyan',
      '#00ff00': 'Green',
      '#ffff00': 'Yellow',
      '#ff8000': 'Orange',
      '#ff0000': 'Red',
      '#ff00ff': 'Magenta',
      '#80ffff': 'Light Cyan',
      '#80ff80': 'Light Green',
      '#ffff80': 'Light Yellow',
      '#ffc080': 'Light Orange',
      '#ff8080': 'Light Red',
      '#ff80ff': 'Light Magenta',
      '#ffffff': 'White',
      '#cccccc': 'Light Gray',
      '#999999': 'Gray',
      '#666666': 'Dark Gray',
      '#333333': 'Darker Gray',
      '#000000': 'Black'
    }
  },
  capitalization: {
    title: _TL_('Change case'),
    image: CAPITALIZATION_SVG,
    onClick: _roosterjs.changeCapitalization,
    dropdownItems: {
      sentence: 'Sentence case.',
      lowercase: 'lowercase',
      uppercase: 'UPPERCASE',
      capitalize: 'Capitalize Each Word'
    }
  },
  bullet: {
    title: _TL_('Bullet'),
    image: BULLETS_SVG,
    onClick: _roosterjs.toggleBullet,
    checked: format => format.isBullet
  },
  numbering: {
    title: _TL_('Numbering'),
    image: NUMBERING_SVG,
    onClick: editor => (0, _roosterjs.toggleNumbering)(editor),
    checked: format => format.isNumbering
  },
  outdent: {
    title: _TL_('Decrease indent'),
    image: OUTDENT_SVG,
    onClick: editor => (0, _roosterjs.setIndentation)(editor, _roosterjs.Indentation.Decrease)
  },
  indent: {
    title: _TL_('Increase indent'),
    image: INDENT_SVG,
    onClick: editor => (0, _roosterjs.setIndentation)(editor, _roosterjs.Indentation.Increase)
  },
  alignLeft: {
    title: _TL_('Align left'),
    image: ALIGNLEFT_SVG,
    onClick: editor => (0, _roosterjs.setAlignment)(editor, _roosterjs.Alignment.Left)
  },
  alignCenter: {
    title: _TL_('Align center'),
    image: ALIGNCENTER_SVG,
    onClick: editor => (0, _roosterjs.setAlignment)(editor, _roosterjs.Alignment.Center)
  },
  alignRight: {
    title: _TL_('Align right'),
    image: ALIGNRIGHT_SVG,
    onClick: editor => (0, _roosterjs.setAlignment)(editor, _roosterjs.Alignment.Right)
  },
  insertLink: {
    title: _TL_('Insert hyperlink'),
    image: CREATELINK_SVG,
    onClick: null,
    dropdownItems: {
      0: 'dummy'
    },
    dropdownRenderer: _insertLinkDialog.renderInsertLinkDialog,
    preserveOnClickAway: true
  },
  unlink: {
    title: _TL_('Remove hyperlink'),
    image: UNLINK_SVG,
    onClick: _roosterjs.removeLink,
    isDisabled: (_editor, format) => !format.canUnlink
  },
  strikethrough: {
    title: _TL_('Strikethrough'),
    image: STRIKETHROUGH_SVG,
    onClick: _roosterjs.toggleStrikethrough,
    checked: format => format.isStrikeThrough
  },
  header: {
    title: _TL_('Header'),
    image: HEADER_SVG,
    onClick: (editor, value) => (0, _roosterjs.toggleHeader)(editor, parseInt(value, 10)),
    dropdownItems: {
      0: 'No header',
      1: 'Header 1',
      2: 'Header 2',
      3: 'Header 3',
      4: 'Header 4',
      5: 'Header 5',
      6: 'Header 6'
    }
  },
  ltr: {
    title: _TL_('Left-to-right'),
    image: LTR_SVG,
    onClick: editor => (0, _roosterjs.setDirection)(editor, _roosterjs.Direction.LeftToRight)
  },
  rtl: {
    title: _TL_('Right-to-left'),
    image: RTL_SVG,
    onClick: editor => (0, _roosterjs.setDirection)(editor, _roosterjs.Direction.RightToLeft)
  },
  undo: {
    title: _TL_('Undo'),
    image: UNDO_SVG,
    onClick: editor => editor.undo(),
    isDisabled: (_editor, format) => !format.canUndo
  },
  redo: {
    title: _TL_('Redo'),
    image: REDO_SVG,
    onClick: editor => editor.redo(),
    isDisabled: (_editor, format) => !format.canRedo
  },
  clearFormat: {
    title: _TL_('Remove formatting'),
    image: REMOVEFORMAT_SVG,
    onClick: editor => {
      if (!editor.getSelectionTraverser()) {
        return;
      }

      (0, _roosterjs.clearFormat)(editor, _roosterjs.ClearFormatMode.AutoDetect);
    }
  },
  // Disabled this for the moment since we remove all formate before pasting.
  // paste: {
  //   title: _TL_('Paste Again'),
  //   onClick: (editor) => {
  //     editor.focus();
  //     const { data } = getLastClipboardData(editor);
  //     editor.paste(data, true);
  //   },
  //   isDisabled: editor => !getLastClipboardData(editor).data,
  // },
  clear: {
    title: _TL_('Clear'),
    onClick: editor => {
      editor.addUndoSnapshot(() => {
        editor.setContent('');
      });
    }
  }
};
exports.ribbonButtons = ribbonButtons;
const RibbonButtons = {
  Bold: 'bold',
  Italic: 'italic',
  Underline: 'underline',
  Font: 'fontName',
  FontSize: 'fontSize',
  TextColor: 'textColor',
  Highlight: 'backColor',
  ChangeCase: 'capitalization',
  Bullet: 'bullet',
  Numbering: 'numbering',
  DecreaseIndent: 'outdent',
  IncreaseIndent: 'indent',
  AlignLeft: 'alignLeft',
  AlignCenter: 'alignCenter',
  AlignRight: 'alignRight',
  InsertHyperlink: 'insertLink',
  RemoveHyperlink: 'unlink',
  Strikethrough: 'strikethrough',
  Header: 'header',
  Ltr: 'ltr',
  Rtl: 'rtl',
  Undo: 'undo',
  Redo: 'redo',
  RemoveFormatting: 'clearFormat',
  Paste: 'paste',
  Clear: 'clear'
};
exports.RibbonButtons = RibbonButtons;

/***/ }),

/***/ 932:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.renderInsertLinkDialog = exports.InsertLinkDialog = void 0;

var _react = _interopRequireWildcard(__webpack_require__(3));

var _underscore = _interopRequireDefault(__webpack_require__(9));

var _propTypes = _interopRequireDefault(__webpack_require__(10));

var _roosterjs = __webpack_require__(925);

var _withDefaultStyles = __webpack_require__(35);

var _TextField = __webpack_require__(933);

var _Dialog = __webpack_require__(934);

var _Button = __webpack_require__(935);

var _insertLinkDialogStyle = __webpack_require__(936);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

const urlInputId = 'ribbon-insert-link-dialog-url-input';
const displayTextInputId = 'ribbon-insert-link-dialog-url-display-text';

const UnstyledInsertLinkDialog = ({
  classes,
  editor,
  displayText,
  url,
  onDismiss,
  i18n
}) => {
  const _useState = (0, _react.useState)(url),
        _useState2 = _slicedToArray(_useState, 2),
        currentUrl = _useState2[0],
        setCurrentUrl = _useState2[1];

  const _useState3 = (0, _react.useState)(displayText),
        _useState4 = _slicedToArray(_useState3, 2),
        currentDisplayText = _useState4[0],
        setCurrentDisplayText = _useState4[1];

  const onHandleDismiss = (0, _react.useCallback)(e => {
    e.preventDefault();
    e.stopPropagation();

    if (e.nativeEvent) {
      // For react 16
      e.nativeEvent.stopImmediatePropagation();
    }

    onDismiss(e);
  }, [onDismiss]);
  const onOk = (0, _react.useCallback)(e => {
    (0, _roosterjs.createLink)(editor, currentUrl
    /* target url */
    , currentUrl
    /* alt text */
    , currentDisplayText
    /* display text */
    );
    onHandleDismiss(e);
  }, [currentDisplayText, currentUrl, editor, onHandleDismiss]);
  const dialogContentProps = (0, _react.useMemo)(() => ({
    type: _Dialog.DialogType.normal,
    title: i18n.getString(_TL_('Insert an external link')),
    closeButtonAriaLabel: i18n.getString(_TL_('Close'))
  }), [i18n]);
  return _react.default.createElement(_Dialog.Dialog, {
    className: "ribbon-insert-link-dialog",
    hidden: false,
    onDismiss: onHandleDismiss,
    dialogContentProps: dialogContentProps,
    modalProps: {
      isBlocking: true
    }
  }, _react.default.createElement("div", {
    className: classes.root
  }, _react.default.createElement("div", {
    className: classes.inputItem
  }, _react.default.createElement("label", {
    htmlFor: urlInputId,
    className: classes.title
  }, i18n.getString(_TL_('Url')), ":", _react.default.createElement(_TextField.TextField, {
    id: urlInputId,
    defaultValue: currentUrl,
    onChange: (e, val) => setCurrentUrl(val)
  }))), _react.default.createElement("div", {
    className: classes.inputItem
  }, _react.default.createElement("label", {
    htmlFor: displayTextInputId,
    className: classes.title
  }, i18n.getString(_TL_('Display text')), ":", _react.default.createElement(_TextField.TextField, {
    id: displayTextInputId,
    defaultValue: currentDisplayText,
    onChange: (e, val) => setCurrentDisplayText(val)
  })))), _react.default.createElement(_Dialog.DialogFooter, null, _react.default.createElement(_Button.PrimaryButton, {
    className: classes.button,
    onClick: onOk,
    disabled: !currentUrl || !currentDisplayText,
    text: i18n.getString(_TL_('OK'))
  }), _react.default.createElement(_Button.DefaultButton, {
    className: classes.button,
    onClick: onHandleDismiss,
    text: i18n.getString(_TL_('Cancel'))
  })));
};

UnstyledInsertLinkDialog.propTypes = {
  classes: _propTypes.default.shape({}).isRequired,
  editor: _propTypes.default.shape({}).isRequired,
  displayText: _propTypes.default.string.isRequired,
  url: _propTypes.default.string.isRequired,
  onDismiss: _propTypes.default.func.isRequired,
  i18n: _propTypes.default.shape({
    getString: _propTypes.default.func
  }).isRequired
};
const InsertLinkDialog = (0, _withDefaultStyles.withDefaultStyles)(UnstyledInsertLinkDialog, _insertLinkDialogStyle.getInsertLinkDialogStyle);
exports.InsertLinkDialog = InsertLinkDialog;

const renderInsertLinkDialog = (editor, i18n, onDismiss = _underscore.default.noop) => {
  const cursorElement = editor.getElementAtCursor();
  const selectionTraverser = editor.getSelectionTraverser();
  const selectionEle = selectionTraverser ? selectionTraverser.currentInlineElement : null;
  let anchor = null;
  let displayText = '';
  let url = '';

  if (cursorElement) {
    anchor = cursorElement.tagName === 'A' ? cursorElement : cursorElement.querySelector('a[href]');
  }

  if (anchor) {
    displayText = anchor.innerText;
    url = anchor.href;
  } else if (selectionEle) {
    displayText = selectionEle.getTextContent();
  }

  return _react.default.createElement(InsertLinkDialog, {
    editor: editor,
    i18n: i18n,
    onDismiss: onDismiss,
    url: url,
    displayText: displayText
  });
};

exports.renderInsertLinkDialog = renderInsertLinkDialog;

/***/ }),

/***/ 933:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__933__;

/***/ }),

/***/ 934:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__934__;

/***/ }),

/***/ 935:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__935__;

/***/ }),

/***/ 936:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getInsertLinkDialogStyle = void 0;

const getInsertLinkDialogStyle = () => ({
  root: {
    width: '300px'
  },
  title: {
    whiteSpace: 'nowrap'
  },
  buttonRow: {
    textAlign: 'center'
  },
  button: {
    width: '80px',
    margin: '10px'
  },
  inputItem: {
    marginBottom: '10px'
  }
});

exports.getInsertLinkDialogStyle = getInsertLinkDialogStyle;

/***/ }),

/***/ 937:
/***/ (function(module, exports, __webpack_require__) {

module.exports = (window.__publicpath__ || __webpack_require__.p) + "static/media/bold.d9f4e7bc.svg";

/***/ }),

/***/ 938:
/***/ (function(module, exports, __webpack_require__) {

module.exports = (window.__publicpath__ || __webpack_require__.p) + "static/media/italic.e0f1843b.svg";

/***/ }),

/***/ 939:
/***/ (function(module, exports, __webpack_require__) {

module.exports = (window.__publicpath__ || __webpack_require__.p) + "static/media/underline.bb6d7e9f.svg";

/***/ }),

/***/ 940:
/***/ (function(module, exports, __webpack_require__) {

module.exports = (window.__publicpath__ || __webpack_require__.p) + "static/media/bullets.7235ce41.svg";

/***/ }),

/***/ 941:
/***/ (function(module, exports, __webpack_require__) {

module.exports = (window.__publicpath__ || __webpack_require__.p) + "static/media/header.15016327.svg";

/***/ }),

/***/ 942:
/***/ (function(module, exports, __webpack_require__) {

module.exports = (window.__publicpath__ || __webpack_require__.p) + "static/media/numbering.005566d5.svg";

/***/ }),

/***/ 943:
/***/ (function(module, exports, __webpack_require__) {

module.exports = (window.__publicpath__ || __webpack_require__.p) + "static/media/outdent.fd588b14.svg";

/***/ }),

/***/ 944:
/***/ (function(module, exports, __webpack_require__) {

module.exports = (window.__publicpath__ || __webpack_require__.p) + "static/media/indent.9397bcc9.svg";

/***/ }),

/***/ 945:
/***/ (function(module, exports, __webpack_require__) {

module.exports = (window.__publicpath__ || __webpack_require__.p) + "static/media/alignleft.99f430f9.svg";

/***/ }),

/***/ 946:
/***/ (function(module, exports, __webpack_require__) {

module.exports = (window.__publicpath__ || __webpack_require__.p) + "static/media/aligncenter.5b38a364.svg";

/***/ }),

/***/ 947:
/***/ (function(module, exports, __webpack_require__) {

module.exports = (window.__publicpath__ || __webpack_require__.p) + "static/media/alignright.1b2574e4.svg";

/***/ }),

/***/ 948:
/***/ (function(module, exports, __webpack_require__) {

module.exports = (window.__publicpath__ || __webpack_require__.p) + "static/media/unlink.340a83a2.svg";

/***/ }),

/***/ 949:
/***/ (function(module, exports, __webpack_require__) {

module.exports = (window.__publicpath__ || __webpack_require__.p) + "static/media/strikethrough.59937ef8.svg";

/***/ }),

/***/ 950:
/***/ (function(module, exports, __webpack_require__) {

module.exports = (window.__publicpath__ || __webpack_require__.p) + "static/media/ltr.1dd6a230.svg";

/***/ }),

/***/ 951:
/***/ (function(module, exports, __webpack_require__) {

module.exports = (window.__publicpath__ || __webpack_require__.p) + "static/media/rtl.6a519b55.svg";

/***/ }),

/***/ 952:
/***/ (function(module, exports, __webpack_require__) {

module.exports = (window.__publicpath__ || __webpack_require__.p) + "static/media/undo.514f0f4d.svg";

/***/ }),

/***/ 953:
/***/ (function(module, exports, __webpack_require__) {

module.exports = (window.__publicpath__ || __webpack_require__.p) + "static/media/redo.e08f61fb.svg";

/***/ }),

/***/ 954:
/***/ (function(module, exports, __webpack_require__) {

module.exports = (window.__publicpath__ || __webpack_require__.p) + "static/media/removeformat.08b09e4f.svg";

/***/ }),

/***/ 955:
/***/ (function(module, exports, __webpack_require__) {

module.exports = (window.__publicpath__ || __webpack_require__.p) + "static/media/backcolor.7ec1774f.svg";

/***/ }),

/***/ 956:
/***/ (function(module, exports, __webpack_require__) {

module.exports = (window.__publicpath__ || __webpack_require__.p) + "static/media/textcolor.f52adea0.svg";

/***/ }),

/***/ 957:
/***/ (function(module, exports, __webpack_require__) {

module.exports = (window.__publicpath__ || __webpack_require__.p) + "static/media/createlink.d153ac3e.svg";

/***/ }),

/***/ 958:
/***/ (function(module, exports, __webpack_require__) {

module.exports = (window.__publicpath__ || __webpack_require__.p) + "static/media/fontsize.94b7a8dc.svg";

/***/ }),

/***/ 959:
/***/ (function(module, exports, __webpack_require__) {

module.exports = (window.__publicpath__ || __webpack_require__.p) + "static/media/fontname.a96b420c.svg";

/***/ }),

/***/ 960:
/***/ (function(module, exports, __webpack_require__) {

module.exports = (window.__publicpath__ || __webpack_require__.p) + "static/media/capitalization.932ad2da.svg";

/***/ }),

/***/ 961:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RibbonPlugin = void 0;

var _roosterjs = __webpack_require__(925);

var _getLastClipboardData = __webpack_require__(962);

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

class RibbonPlugin {
  constructor() {
    _defineProperty(this, "registerRef", ref => {
      this.ribbon = ref && ref.current;
    });
  }

  initialize(editor) {
    this.editor = editor;
  }

  dispose() {
    this.editor = null;
  }

  getEditor() {
    return this.editor;
  }

  onPluginEvent(event) {
    if (this.ribbon) {
      // Update the paste data only when user has tried to paste something, otherwise set it to null
      if (event.eventType === _roosterjs.PluginEventType.KeyDown || event.eventType === _roosterjs.PluginEventType.MouseUp) {
        const clipboardDataWrapper = (0, _getLastClipboardData.getLastClipboardData)(this.editor);
        clipboardDataWrapper.data = null;
        this.ribbon.forceUpdate();
      } else if (event.eventType === _roosterjs.PluginEventType.ContentChanged) {
        // Only trigger by paste
        const clipboardDataWrapper = (0, _getLastClipboardData.getLastClipboardData)(this.editor);

        if (event.source === _roosterjs.ChangeSource.Paste) {
          clipboardDataWrapper.data = event.data;
        } else {
          clipboardDataWrapper.data = null;

          if (event.source === _roosterjs.ChangeSource.CreateLink || event.source === _roosterjs.ChangeSource.AutoLink) {
            // Replace the node target attr directly
            const hyperLinkNode = event.data;
            hyperLinkNode.target = '_blank';
          }
        }

        this.ribbon.forceUpdate();
      } else if (event.eventType === _roosterjs.PluginEventType.EditorReady) {
        this.ribbon.forceUpdate();
      }
    }
  }

}

exports.RibbonPlugin = RibbonPlugin;

/***/ }),

/***/ 962:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getLastClipboardData = void 0;

const getLastClipboardData = // https://microsoft.github.io/roosterjs/docs/classes/roosterjs_editor_core.editor.html#getcustomdata
// Will call the second paramater to store the value to that key if undefiend
// Use object so we could set and get value from it
editor => editor.getCustomData('LAST_CLIPBOARD_DATA', () => ({
  data: null
}));

exports.getLastClipboardData = getLastClipboardData;

/***/ }),

/***/ 963:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ContentStatePlugin = void 0;

var _underscore = _interopRequireDefault(__webpack_require__(9));

var _roosterjs = __webpack_require__(925);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// This will be inserted when click empty format for empty content
const ZERO_WIDTH_SPACE = '\u200B';

class ContentStatePlugin {
  constructor(options) {
    _defineProperty(this, "registerObs", obs => {
      this.stateObserver = obs;
    });

    this.options = options;
  }

  initialize(editor) {
    this.editor = editor;
  }

  dispose() {
    this.editor = null;
  }

  onPluginEvent(event) {
    if (this.stateObserver) {
      // Paste or change by key press
      if (event.eventType === _roosterjs.PluginEventType.ContentChanged || event.eventType === _roosterjs.PluginEventType.KeyUp || event.eventType === _roosterjs.PluginEventType.KeyDown || event.eventType === _roosterjs.PluginEventType.CompositionEnd || event.eventType === _roosterjs.PluginEventType.EditorReady) {
        // We don't trigger bubble event to consumer when it is in init phase
        const shouldBubble = !(event.eventType === _roosterjs.PluginEventType.EditorReady);
        const rawContent = this.editor.getContent(_roosterjs.GetContentMode.PlainText); // Empty content still wrap with tags or special empty char

        if (_underscore.default.isEmpty(rawContent) || rawContent === ZERO_WIDTH_SPACE) {
          this.stateObserver('', shouldBubble);
        } else {
          if (this.options.pasteAsText) {
            const imgNodes = this.editor.queryElements('img');

            if (!_underscore.default.isEmpty(imgNodes)) {
              imgNodes.forEach(node => this.editor.deleteNode(node));
            }
          }

          this.stateObserver(this.editor.getContent(), shouldBubble);
        }
      }
    }
  }

}

exports.ContentStatePlugin = ContentStatePlugin;

/***/ }),

/***/ 964:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDefaultFormat = void 0;

const getDefaultFormat = (options = {}) => ({
  fontSize: options.fontSize || '14px',
  bold: options.bold || false,
  italic: options.italic || false,
  underline: options.underline || false,
  textColor: options.textColor || 'inherit'
});

exports.getDefaultFormat = getDefaultFormat;

/***/ }),

/***/ 965:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ContentFilterPlugin = void 0;

var _roosterjs = __webpack_require__(925);

class ContentFilterPlugin {
  initialize(editor) {
    this.editor = editor;
  }

  dispose() {
    this.editor = null;
  }

  getEditor() {
    return this.editor;
  }

  onPluginEvent(event) {
    if (event.eventType === _roosterjs.PluginEventType.BeforeCutCopy) {
      const clonedRoot = event.clonedRoot; // Remove default white color for wrapped div

      clonedRoot.style.backgroundColor = 'unset';
    } else if (event.eventType === _roosterjs.PluginEventType.BeforePaste) {
      const fragment = event.fragment;
      const elements = fragment.querySelectorAll('a'); // eslint-disable-next-line no-param-reassign

      elements.forEach(ele => {
        ele.target = '_blank';
      });
    }
  }

}

exports.ContentFilterPlugin = ContentFilterPlugin;

/***/ })

/******/ })});;
